module.exports = __webpack_public_path__ + "static/media/mobileScreenshot02.574b2aee.jpg";